import {FC, useEffect, useState} from 'react';

import {Box, FormHelperText, TextFieldProps} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {useIMask} from 'react-imask';

import {Input} from 'components/input/Input';

type InputProps = Omit<TextFieldProps, 'defaultProps' | 'value'> & {value?: string | number};

/**
 * Component to represent Thai local phone number
 */
export const ThaiPhoneNumber: FC<InputProps> = ({onChange, ...props}) => {
  const {t} = useTranslation();
  const [opts] = useState({
    mask: '000 000 0000'
  });

  const {ref, setValue} = useIMask(opts, {
    onAccept: (v) => {
      if (onChange) {
        onChange(v as any);
      }
    }
  });

  useEffect(() => {
    if (props.value) {
      setValue(props.value as any);
    }
  }, [setValue, props.value]);

  return (
    <>
      <Input type={'tel'} ref={ref} {...props} value={props.value} />
      {!props?.error && (
        <Box pl={2}>
          <FormHelperText>{t('global.example')}: 088 888 xxxx</FormHelperText>
        </Box>
      )}
    </>
  );
};
